/* eslint-disable no-undef,no-param-reassign,import/named,consistent-return */
/**
 * Created by chengzhenfu on 2019/5/5.
 * Modified by  on .
 *axios 封装
 */
import baseURL from "@/configs/baseUrl";
import Axios from "axios";
import router from "@/router/index";
import utils from "@/jslibs/utils";

const fetch = Axios.create({
  withCredentials: false,
  baseURL,
  // timeout: 200000, // 设置超时时间
});
// 请求发送前拦截，根据地址重新配置域名，再子路由请求时必须加/ 例如：请求 localhost:80/app/inset  fetch.get('/app/inset');
fetch.interceptors.request.use(
  function (config) {
    const { method } = config;
    // 后期改成从cookies中获取
    config.headers = {
      "X-Access-Token": utils.getCookie("X-Access-Token") || "",
    };
    if (method === "get" || method === "delete") {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    }
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  },
);

// 添加响应拦截器
fetch.interceptors.response.use(
  function (response) {
    const res = response.data;
    const status = response.status;
    if (status === 200) {
      return res.result;
    } else if (status === 401) {
      router.push("/login");
      vm.$message(res.message);
    } else if (status === 403) {
      vm.$message("权限不够");
    } else {
      vm.$message.error(res.message || "Error");
      return Promise.reject(res);
    }
  },
  function (error) {
    // 对响应错误做点什么
    const { status, data } = error.response;
    const message = data.error.message;
    switch (status) {
      case 401:
        router.push("/login");
        vm.$message.error(message);
        throw error.response;
      case 403:
        vm.$message.error(message);
        throw error.response;
      case 500:
        vm.$message.error("500服务器错误");
        throw error.response;
      default:
        vm.$message.error(message);
        return Promise.reject(data);
    }
  },
);

export default fetch;
